import React from "react"

export const languages = {
  en: {
    locale: "en",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    readMoreNews: "Read more news",
    references: "References",
    modules: "Modules",
    story: "Story",
    cover: "Cover letter",
    website: "Website",
    discoverMoreClients: "Discover more clients that have relied on MECMATICA",
    contactForm: {
      title: "Contact us",
      subtitle: "to receive more information"
    },
    formInputTexts: {
      fileSelect: "Choose file",
      birthday: "Birthday",
      loading: "Loading",
      submit: "Submit",
      submitApplication: "Submit your application",
      email: "Email",
      fullName: "Full name",
      firstName: "First name",
      lastName: "Last name",
      company: "Company",
      policy:
        "I accept that my personal data will be used in accordance with the <a href='https://www.iubenda.com/privacy-policy/59424743'>privacy policy</a> and the <a href='https://www.iubenda.com/privacy-policy/59424743/cookie-policy'>cookie policy</a>. I accept that my personal data will be used to inform me about new products and exclusive products and for direct marketing purposes. Regarding the services offered as well as analyzing my previous purchases in order to send me proposals that reflect my interests.",
      privacy:
        "I consent to the use of my personal data to be updated on new arrivals, exclusive products and for direct marketing purposes related to the services offered and to receive proposals in line with my interests through the analysis of my previous purchases",
      phone: "Phone",
      message: "Message",
      role: "Job position",
    },
  },
  it: {
    locale: "it",
    discoverMore: "Scopri di più",
    all: "Tutti",
    search: "Cerca",
    results: "risultati",
    noResults: "Nessun risultato",
    download: "Scarica",
    latestArticles: "Ultime news",
    readMoreNews: "Leggi tutte le news",
    references: "Referenze",
    modules: "I moduli di Metronomo.Net",
    story: "Storia",
    cv: "CV",
    cover: "Cover letter",
    website: "Sito web",
    discoverMoreClients:
      "Scopri altri clienti che si sono affidati a MECMATICA",
    contactForm: {
      title: "Contattaci",
      subtitle: "per ricevere maggiori informazioni"
    },
    formInputTexts: {
      fileSelect: "Scegli il file",
      birthday: "Data di nascita",
      loading: "Caricamento...",
      submit: "Invia la richiesta",
      submitApplication: "Invia la tua candidatura",
      email: "Email",
      fullName: "Full name",
      firstName: "Nome",
      lastName: "Cognome",
      company: "Azienda",
      address: "Indirizzo",
      city: "Città",
      province: "Provincia",
      zipCode: "CAP",
      policy:
        "Accetto che i miei dati personali vengano utilizzati in conformità con la <a href='https://www.iubenda.com/privacy-policy/34811234' target='_blank' rel='noopener noreferrer'>privacy policy</a> e la <a href='https://www.iubenda.com/privacy-policy/34811234/cookie-policy' target='_blank' rel='noopener noreferrer'>cookie policy</a>",
      privacy:
        " Acconsento all'uso dei miei dati personali per essere aggiornato sui nuovi arrivi, prodotti in esclusiva e per le finalità di marketing  correlate ai servizi offerti e ricevere proposte in linea con i miei interessi attraverso l'analisi dei miei precedenti acquisti",
      phone: "Telefono",
      message: "Messaggio",
      role: "Posizione lavorativa",
    },
  },
  de: {
    locale: "de",
    discoverMore: "Wer wir sind",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "Keine Ergebnisse",
    download: "Download",
    latestArticles: "Neueste Nachrichten",
    readMoreNews: "Lesen Sie weitere Neuigkeiten",
    references: "References",
    modules: "Modules",
    story: "Story",
    cover: "Cover letter",
    website: "Website",
    discoverMoreClients:
      "Entdecken Sie weitere Kunden, die sich auf MECMATICA verlassen haben",
    contactForm: {
      title: "Kontaktiere uns",
      subtitle: "um weitere Informationen zu erhalten"
    },
    formInputTexts: {
      fileSelect: "Datei wählen",
      birthday: "Geburtstag",
      loading: "Wird geladen",
      submit: "Submit",
      submitApplication: "Reichen Sie Ihre Bewerbung ein",
      email: "Email",
      fullName: "Full name",
      firstName: "Vorchname",
      lastName: "Nachname",
      company: "Company",
      phone: "Telefone",
      policy:
        "Ich erkläre mich damit einverstanden, dass meine personenbezogenen Daten im Einklang mit der <a href='https://www.iubenda.com/privacy-policy/22062360' target='_blank' rel='noopener noreferrer'>privacy policy</a> und der <a href='https://www.iubenda.com/privacy-policy/22062360/cookie-policy' target='_blank' rel='noopener noreferrer'>cookie policy</a> verwendet werden. Ich bin damit einverstanden, dass meine personenbezogenen Daten verwendet werden, um mich über Neuheiten und exklusive Produkte zu informieren und zum Zwecke des Direktmarketings in Bezug auf die angebotenen Dienstleistungen sowie durch die Analyse meiner früheren Einkäufe für die Zusendung von Vorschlägen, die meine Interessen widerspiegeln.",
      privacy:
        "Ich stimme der Verwendung meiner personenbezogenen Daten zu, um über Neuankömmlinge und exklusive Produkte auf dem Laufenden zu bleiben und um Direktmarketingzwecke im Zusammenhang mit den angebotenen Dienstleistungen zu nutzen und um durch die Analyse meiner vorherigen Einkäufe Vorschläge zu erhalten, die meinen Interessen entsprechen.",
      message: "Nachricht",
      role: "Berufliche Stellung",
    },
  },
  fr: {
    locale: "fr",
    discoverMore: "Découvrir plus",
    all: "All",
    search: "Recherche",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Dernières nouvelles",
    readMoreNews: "Lire plus de nouvelles",
    references: "References",
    modules: "Modules",
    story: "Story",
    cover: "Cover letter",
    website: "Website",
    discoverMoreClients:
      "Découvrez plus de clients qui ont fait confiance à MECMATICA",
    contactForm: {
      title: "Contactez-nous",
      subtitle: "pour recevoir plus d'informations"
    },
    formInputTexts: {
      fileSelect: "Choisir le fichier",
      birthday: "Anniversaire",
      loading: "Loading",
      submit: "Submit",
      submitApplication: "Soumettez votre candidature",
      email: "Email",
      fullName: "Full name",
      firstName: "Prénom",
      lastName: "Nom de famille",
      company: "Company",
      phone: "Téléphone",
      message: "Message",
      policy:
        "J'accepte que mes données personnelles soient utilisées conformément à la <a href='https://www.iubenda.com/privacy-policy/86946756' target='_blank' rel='noopener noreferrer'>politique de confidentialité</a> et à la <a href='https://www.iubenda.com/privacy-policy/86946756/cookie-policy' target='_blank' rel='noopener noreferrer'>politique en matière de cookies</a>. J'accepte que mes données personnelles soient utilisées pour m'informer sur les nouveaux produits et produits exclusifs et à des fins de marketing direct Concernant les services proposés ainsi que en analysant mes achats précédents afin de m'envoyer des propositions qui reflètent mes intérêts.",
      privacy:
        "J'accepte l'utilisation de mes données personnelles pour être informé des nouveautés, des produits exclusifs et à des fins de marketing direct liées aux services proposés et pour recevoir des propositions conformes à mes intérêts grâce à l'analyse de mes achats précédents",
      role: "Job position",
    },
  },
}

export const i18nContext = React.createContext(languages.it)
